module.exports = __webpack_public_path__ + "img/cam.afeb47da.svg";